module.exports = __webpack_public_path__ + "assets/824fe5804c62e9b0e2f9dd9efb30b4a0.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Quadon-Regular.woff
 ** module id = 1742
 ** module chunks = 1
 **/